<template>
  <div class="landing" fluid fill-height>
    <div v-if="!error">
      <v-progress-linear indeterminate color="primary" height="40"></v-progress-linear>
      <v-card-text class="text-subtitle-1 text-center">
        {{ $t('message.loading_admin') }}
      </v-card-text>
    </div>
    <v-card-text v-if="error" class="text-center">
      <div class="error--text pa-2 text-h5">{{ error }}</div>
      <div class="error--text pa-2 text-h6">{{ $t('message.restart_app') }}</div>
    </v-card-text>
  </div>
</template>

<script>
import Api from "@/services/Api";


export default {
  data() {
    return {
      token: this.$route.params.token,
      appVersion: this.$route.query.appv,
      redirect: this.$route.query.r,
      embed: this.$route.query.embed,
      lat: this.$route.query.lat,
      lon: this.$route.query.lon,
      closeAndReload: false,
      error: null,
    }
  },
  created() {
    if (localStorage.token) {
      window.location = process.env.VUE_APP_PUBLIC_PATH;
    } else {
      this.login();
    }
  },
  methods: {
    reload() {
      window.location.reload(true);
    },
    async login() {
      try {
        if (this.token) {
          console.log('Starting login with token: ', this.token);
          Api()
            .post(
              "users/authapp", {
              token: this.token,
              appVersion: this.appVersion ? this.appVersion : null
            })
            .then((response) => {
              if (response)
                this.processLoggedIn(response);
              else
                this.error = this.$t("message.invalid_user") + ": TLGN01";
            }).catch((err) => {
              console.log('HERE')
              if (err.response) {
                if (err.response.status == 404)
                  this.error = this.$t("message.invalid_user") + ": TLGN02";
                else if (err.response.status == 400)
                  this.error = this.$t("message.invalid_password") + ": TLGN03";
                else
                  this.error = this.$t("message.error_generic") + ": TLGN04";
              } else {
                console.log('HERE3')
                this.error = this.$t("message.error_generic") + ": TLGN05";
              }
            });
        } else {
          this.error = this.$t("message.error_generic") + ": TLGN06";
        }
      } catch (err) {
        console.lof('Error loging in: ', err);
        this.error = this.$t("message.error_generic") + ": TLGN07";
      }
    },
    processLoggedIn(response) {
      if (response.data.token) {
        try {
          this.$store.dispatch("setToken", response.data.token);
          this.$store.dispatch("setUser", response.data.user);
          this.$store.dispatch("setName", response.data.user.fName);
          this.$store.dispatch("setHidden", response.data.user.hidden);
          this.$store.dispatch("setInApp", true);

          this.$store.dispatch("setUserImage",
            (response.data.user.userImageSmall ?
              response.data.user.userImageSmall :
              response.data.user.userImage));
          this.$store.dispatch("setLanguage", response.data.user.lang);
          this.$i18n.locale = response.data.user.lang;
          localStorage.token = response.data.token;
          if (
            response.data.hasLatestAgreement &&
            response.data.hasLatestAgreement == true
          ) {
            localStorage.hasAgreements = true;
            this.$store.dispatch("setHasAgreements", true);
          } else {
            localStorage.hasAgreements = false;
            this.$store.dispatch("setHasAgreements", false);
          }
          if (this.$store.state.managedAcademy) {
            Api()
              .get("admins/managedacademy/" + this.$store.state.managedAcademy + "/manager/me")
              .then((response) => {
                const loggedUser = response.data.data;
                if (loggedUser) {
                  this.$store.dispatch("setLanguage", loggedUser.language);
                  this.$i18n.locale = loggedUser.language;
                  this.darkTheme = loggedUser.darkMode;
                  this.$vuetify.theme.dark = this.darkTheme;
                  let theme = 'light';
                  if (this.darkTheme)
                    theme = 'dark';
                  this.$store.dispatch("setTheme", theme);
                  console.log('Admin window.replace to with managed academy: ', process.env.VUE_APP_PUBLIC_PATH)
                  window.location = process.env.VUE_APP_PUBLIC_PATH;
                }
              });
          } else {
            console.log('Admin window.replace to w/o managed academy: ', process.env.VUE_APP_PUBLIC_PATH)
            window.location = process.env.VUE_APP_PUBLIC_PATH;
          }
        } catch (err) {
          this.error = this.$t("message.error_generic") + ": TLGN08";
        }
      } else {
        this.error = this.$t("message.error_generic") + ": TLGN09";
      }
    }
  }
}
</script>

<style scoped></style>